import PropTypes from 'prop-types'; // Currency values

export var SPACING = [0, 1, 2, 3, '3-half', 4, 5];
export var propTypes = {
  children: PropTypes.node,

  /**
   *  Vertical spacing based on the Currency spacing system (1-5).
   */
  spacing: PropTypes.shape({
    top: PropTypes.oneOf(SPACING),
    bottom: PropTypes.oneOf(SPACING)
  })
};
export var defaultProps = {
  spacing: {
    top: 0,
    bottom: 0
  }
};